var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_4_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_4_2",
    "data-name": "Artboard 4 \u2013 2",
    clipPath: "url(#clip-Artboard_4_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_03b_Checkmark",
    transform: "translate(-0.5 117.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000183949044655107214610000000890460927950755512_",
    transform: "translate(0.5 11.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M550.7,1280.032c437.165-263.806,926.015-709.586,1329.8-1032.614C1816.968,180.659,1752.363,113.9,1688.834,47.14c-10.768-11.844-23.689-23.689-39.84-24.765-14-1.077-26.919,8.614-38.764,17.228C1282.895,294.8,968.48,677.046,605.612,878.4c-19.382,10.768-39.84,20.458-61.375,16.151-19.382-4.307-33.38-20.458-45.224-35.533C444.1,791.182,409.641,708.272,354.726,640.436c-26.919-34.456-48.454-51.685-68.913-55.992-36.61-8.614-69.989,21.535-123.827,64.606C115.685,685.66,64,714.732,17.7,751.342c134.6,129.211,299.34,374.713,433.935,503.924,15.075,15.074,32.3,30.149,52.761,33.379,16.152,1.077,33.38-1.077,46.3-8.614",
    transform: "translate(167.503 89.608)",
    fill: "#79de75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M847.911,1706.722C380.6,1706.722.5,1326.625.5,859.311S380.6,11.9,847.911,11.9c226.12,0,439.319,88.294,599.756,248.732,10.767,10.768,10.767,26.919,0,37.687s-26.919,10.768-37.687,0c-149.67-149.67-349.947-232.58-562.069-232.58-438.242,0-794.65,356.408-794.65,794.65s356.408,794.65,794.65,794.65,794.65-356.408,794.65-794.65a25.508,25.508,0,0,1,25.842-25.842,26.2,26.2,0,0,1,25.842,25.842c2.153,466.238-379.02,846.334-846.334,846.334",
    transform: "translate(-0.5 -11.9)",
    fill: "#c1c1c1"
  }))))));
};
export default __webpack_public_path__ + "static/media/check1.d2d6bdb7.svg";
export { SvgComponent as ReactComponent };